var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "签到",
        width: "584px",
        loading: _vm.loading,
        height: "auto",
        "show-close": true,
        top: _vm.top,
        drag: _vm.drag,
        modal: false,
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticClass: "sign" }, [
        !_vm.ifCountdown
          ? _c(
              "div",
              { staticClass: "pageWrapForm" },
              [
                _c(
                  "el-form",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    ref: "form",
                    attrs: {
                      model: _vm.form,
                      "label-width": "80px",
                      size: "small",
                      rules: _vm.rules,
                    },
                    nativeOn: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "签到方式", prop: "signType" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "245px" },
                            attrs: { disabled: !_vm.form.ifEdit },
                            on: { change: _vm.onhandleChangeSignType },
                            model: {
                              value: _vm.form.signType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "signType", $$v)
                              },
                              expression: "form.signType",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "立即发送", value: 1 },
                            }),
                            _c("el-option", {
                              attrs: { label: "定时发送", value: 2 },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.form.signType === 2
                      ? _c(
                          "el-form-item",
                          {
                            attrs: { label: "发送时间", prop: "signSendTime" },
                          },
                          [
                            _c("AppTimePicker", {
                              attrs: {
                                "picker-options": _vm.pickerOptions,
                                disabled: !_vm.form.ifEdit,
                              },
                              model: {
                                value: _vm.form.signSendTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "signSendTime", $$v)
                                },
                                expression: "form.signSendTime",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: "签到引导语", prop: "signGuideWord" } },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: !_vm.form.ifEdit,
                            type: "textarea",
                            autosize: { minRows: 2, maxRows: 4 },
                            placeholder: "请输入内容",
                            maxlength: "50",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.form.signGuideWord,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "signGuideWord", $$v)
                            },
                            expression: "form.signGuideWord",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "签到时长", prop: "signDuration" } },
                      [
                        _vm.form.ifEdit
                          ? [
                              _c(
                                "div",
                                { staticClass: "signDurationBox" },
                                _vm._l(_vm.signTimeOption, function (item) {
                                  return _c(
                                    "div",
                                    {
                                      key: item.value,
                                      staticClass: "signDurationItem",
                                      class: {
                                        active:
                                          item.value === _vm.form.signDuration,
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.form.signDuration = item.value
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(item.label) + " ")]
                                  )
                                }),
                                0
                              ),
                            ]
                          : [
                              _c("div", { staticClass: "signDurationEdit" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("getOptionsValue")(
                                      _vm.form.signDuration,
                                      _vm.signTimeOption
                                    )
                                  )
                                ),
                              ]),
                            ],
                      ],
                      2
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "m-t-48" },
                      [
                        _vm.form.signId && _vm.form.ifEdit
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  loading: _vm.loading,
                                  type: "primary",
                                },
                                on: { click: _vm.updateLiveRoomSign },
                              },
                              [_vm._v("保存")]
                            )
                          : _vm._e(),
                        _vm.form.signId && !_vm.form.ifEdit
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.onhandleEditSign },
                              },
                              [_vm._v("编辑")]
                            )
                          : _vm._e(),
                        _vm.form.signId
                          ? _c(
                              "el-button",
                              {
                                staticClass: "btn_primary",
                                on: {
                                  click: function ($event) {
                                    return _vm.cancalLiveRoomSign(
                                      _vm.form.signId
                                    )
                                  },
                                },
                              },
                              [_vm._v("取消签到")]
                            )
                          : _vm._e(),
                        !_vm.form.signId
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "small",
                                  loading: _vm.loading,
                                  type: "primary",
                                },
                                on: { click: _vm.onhandleStart },
                              },
                              [_vm._v("开始签到")]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.onhandleCancel },
                          },
                          [_vm._v("取消")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm.ifCountdown
          ? _c("div", { staticClass: "pageWrapCountDown" }, [
              _c(
                "div",
                { staticClass: "pageWrapCountDownTime" },
                [
                  [
                    _c("div", { staticClass: "pageWrapCountDownTimeTips" }, [
                      _vm._v(_vm._s(_vm.form.signGuideWord)),
                    ]),
                    _c("div", { staticClass: "pageWrapCountDownTimeNumber" }, [
                      _vm.countNumber >= 60
                        ? _c("div", { staticClass: "downTimeNumber m-r-10" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWaitingTimeM")(_vm.countNumber)
                              )
                            ),
                          ])
                        : _vm._e(),
                      _vm.countNumber >= 60
                        ? _c("div", { staticClass: "downTimeUnit m-r-8" }, [
                            _vm._v("分"),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "downTimeNumber m-r-8" }, [
                        _vm._v(
                          _vm._s(_vm._f("filterWaitingTimeS")(_vm.countNumber))
                        ),
                      ]),
                      _c("div", { staticClass: "downTimeUnit" }, [
                        _vm._v("秒"),
                      ]),
                    ]),
                  ],
                ],
                2
              ),
              _c("div", { staticClass: "pageWrapCountDownPeople" }, [
                _vm._v("当前签到人数" + _vm._s(_vm.signCount) + "人"),
              ]),
              _c(
                "div",
                { staticClass: "pageWrapCountDownBtn" },
                [
                  _vm.signForm.ifSignStart === 1 ||
                  _vm.signForm.ifSignStart === 3
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "small",
                            loading: _vm.loading || _vm.countNumber <= 0,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.drawPrizeAhead(_vm.form.signId)
                            },
                          },
                        },
                        [_vm._v("结束签到")]
                      )
                    : _vm._e(),
                  _vm.signForm.ifSignStart === 1 ||
                  _vm.signForm.ifSignStart === 3
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "small", loading: _vm.loading },
                          on: { click: _vm.onhandleCancel },
                        },
                        [_vm._v("取消")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
      _c(
        "div",
        {
          staticClass: "signUserInfo",
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _vm.signForm.ifSignStart === 0
            ? _c("span", { on: { click: _vm.openSignLogDialog } }, [
                _vm._v("签到记录"),
              ])
            : _vm._e(),
          _vm.signForm.ifSignStart === 2
            ? _c("span", { on: { click: _vm.openDialog } }, [
                _vm._v("签到结果"),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }